import { createRoutine } from "redux-saga-routines";

export const loadAll = createRoutine("CALL/LOAD_ALL");
export const loadOne = createRoutine("CALL/LOAD_ONE");
export const update = createRoutine("CALL/UPDATE");
